export default __webpack_public_path__ + "static/tecnologia-blockchain-029570793064b2a685e150af89378dcb.jpg";